import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import CustomerPage from "@/pages/CustomerPage";
import { LoginScreen } from "@/pages/LoginScreen";
import AdminDashboard from "@/pages/AdminDashboard";
import VendorPortal from "@/pages/VendorPortal";
import ChangePassword from "@/pages/ChangePassword";
import MandatoryTwoFactorSetup from "@/pages/MandatoryTwoFactorSetup";
import PayoutRequest from "@/pages/PayoutRequest";
import { AccessBlockListener, AccessGate } from "@/components/AccessGate";

function Protected({ role, children }) {
  const { user, checked } = useAuth();
  const loginPath = role === "merchant" ? "/merchant/login" : role === "super_admin" ? "/super-admin/login" : "/branch/login";
  if (!checked) return <div className="min-h-screen bg-[#0A0A0A]" />;
  if (!user) return <Navigate to={loginPath} replace />;
  if (user.role !== role) return <Navigate to={loginPath} replace />;
  if (user.must_change_password) return <ChangePassword />;
  if (!user.totp_enabled) return <MandatoryTwoFactorSetup />;
  return children;
}

function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const map = {
      "/": "Pay via UPI — ABCD Pay",
      "/branch/login": "Branch Login — ABCD Pay",
      "/branch": "Branch Dashboard — ABCD Pay",
      "/super-admin/login": "Super Admin Login — ABCD Pay",
      "/super-admin": "Super Admin Console — ABCD Pay",
      "/merchant/login": "Merchant Login — ABCD Pay",
      "/merchant": "Merchant Portal — ABCD Pay",
    };
    document.title = map[pathname] || "ABCD Pay — Instant UPI Payment Verification";
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <RouteTitle />
        <AuthProvider>
          <AccessBlockListener>
          <Routes>
            <Route path="/" element={<AccessGate scope="public"><CustomerPage /></AccessGate>} />
            <Route path="/payout-request" element={<AccessGate scope="public"><PayoutRequest /></AccessGate>} />
            <Route path="/branch/login" element={<AccessGate scope="login"><LoginScreen role="branch" /></AccessGate>} />
            <Route path="/merchant/login" element={<AccessGate scope="login"><LoginScreen role="merchant" /></AccessGate>} />
            <Route path="/branch" element={<Protected role="branch"><AdminDashboard /></Protected>} />
            <Route path="/super-admin/login" element={<LoginScreen role="super_admin" />} />
            <Route path="/super-admin" element={<Protected role="super_admin"><AdminDashboard /></Protected>} />
            <Route path="/merchant" element={<Protected role="merchant"><VendorPortal /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </AccessBlockListener>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
